/**************************************************************************
 * ADOBE CONFIDENTIAL
 *
 * Copyright 2024 Adobe
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of Adobe
 * and its suppliers, if any. The intellectual and technical concepts contained
 * herein are proprietary to Adobe and its suppliers and are protected by all
 * applicable intellectual property laws, including trade secret and copyright
 * laws. Dissemination of this information or reproduction of this material is
 * strictly forbidden unless prior written permission is obtained from Adobe.
 *
 **************************************************************************/
import { FC, useEffect } from "react";

import { useNavigate } from "react-router";
import { Login } from "./Login/Login";
import { Quizzer } from "./Quizzer";
import { Main } from "./Main/main";

export const RedirectToNewReport: FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/report/new");
  }, [navigate]);

  return null;
};

export type ViewType = {
  id: string;
  path: string;
  title: string;
  defaultProps: object;
  Component: FC;
};

export const views: ViewType[] = [
  {
    id: "main",
    path: "/",
    title: "BOB Quizzer",
    defaultProps: {},
    Component: Main,
  },
  {
    id: "Quizzer",
    path: "/quizzer",
    title: "BOB Quizzer",
    defaultProps: {},
    Component: Quizzer,
  },
  {
    id: "Login",
    path: "/login",
    title: "Login",
    defaultProps: {},
    Component: Login,
  },
];
